module.exports = require("echarts-stat");